import React from 'react';
import { useTranslation } from 'react-i18next';

const Offer = () => {
  const { t } = useTranslation('offer');
  
  return (
    <section id='offer'>
      <div className='container tc'>
        <div className='s-48'></div>
        <h3 className='title-sub'>{t('offer.header.title')}</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          {t('offer.header.subtitle')}
        </h4>
        <div className='s-60'></div>
        <div className='row'>
          <div className='col-lg-4'>
            <div className='c-card' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <p className='title-icon'>{t('offer.cards.learning.icon')}</p>
              <h4 className='c-dark p-b-8'>{t('offer.cards.learning.title')}</h4>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p className='c-text'>
                  {t('offer.cards.learning.description1')}<br />{t('offer.cards.learning.description2')}
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <p className='title-icon'>{t('offer.cards.achievements.icon')}</p>
              <h4 className='c-dark p-b-8'>{t('offer.cards.achievements.title')}</h4>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p className='c-text'>
                  {t('offer.cards.achievements.description')}
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <p className='title-icon'>{t('offer.cards.community.icon')}</p>
              <h4 className='c-dark p-b-8'>{t('offer.cards.community.title')}</h4>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p className='c-text'>
                  {t('offer.cards.community.description')}
                </p>
              </div>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='s-32'></div>
          <div className='col-lg-4'>
            <div className='c-card' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <p className='title-icon'>{t('offer.cards.growth.icon')}</p>
              <h4 className='c-dark p-b-8'>{t('offer.cards.growth.title')}</h4>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p className='c-text'>
                  {t('offer.cards.growth.description')}
                </p>
              </div>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <p className='title-icon'>{t('offer.cards.theory.icon')}</p>
              <h4 className='c-dark p-b-8'>{t('offer.cards.theory.title')}</h4>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p className='c-text'>
                  {t('offer.cards.theory.description')}
                </p>
              </div>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <p className='title-icon'>{t('offer.cards.practice.icon')}</p>
              <h4 className='c-dark p-b-8'>{t('offer.cards.practice.title')}</h4>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p className='c-text'>
                  {t('offer.cards.practice.description')}
                </p>
              </div>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='s-48'></div>
        </div>
      </div>
    </section>
  );
};

export default Offer;
